let username = ''
try {
if (localStorage.getItem('username') != null) {
    username = localStorage.getItem('username')
}
} catch (e) {
    username = ''
}

export default username